import { useMemo } from "react";
import { toast as notify, Renderable, Toast, ToastOptions, ValueOrFunction } from "react-hot-toast";

type Message = ValueOrFunction<Renderable, Toast>;
type ToastHandler = (message: Message, options?: ToastOptions) => string;

export const useNotification = () => {
  // WORK this should be disabled in extension
  const createHandler =
    // eslint-disable-next-line
    (method: ToastHandler) => (msg: Message, data?: any, options?: ToastOptions) => {
      if (data) {
        switch (method.name) {
          case "error":
            console.error(data);
            break;
          default:
            console.info(data);
        }
      }
      const defaultOptions: Partial<ToastOptions> = {
        duration: 5000,
      };
      return method(msg, { ...defaultOptions, ...options });
    };

  const notification = useMemo(
    () => ({
      toast: {
        success: createHandler(notify.success),
        error: createHandler(notify.error),
        loading: createHandler(notify.loading),
        custom: createHandler(notify.custom),
        info: createHandler(notify),
        promise: notify.promise,
        dismiss: notify.dismiss,
        remove: notify.remove,
      },
    }),
    [],
  );

  return notification;
};
